












    import {
        Component,
        Vue
    } from "vue-property-decorator"
import Graph from "../components/Graphs/Graph.vue";
import LinearGraph from "../components/Graphs/LinearGraph.vue";

    @Component({
        components: {
            graph: Graph,
            linear: LinearGraph
        }
    })
    export default class Graphs extends Vue {
        data() {
            return {
                PageTitle: "Graphs"
            }
        }
    }
